import { createContext, useMemo } from "react";
import { ProductPrice } from "src/api/types";
import Loading from "src/components/Loading/Loading";
import { useProduct } from "../ProductProvider";
import { useGetProductPricesQuery } from "src/api/services/productsApi";
import { useParams, useSearchParams } from "react-router-dom";
import { MatchParam } from "src/constants/matches";

export const PricesContext = createContext<ProductPrice[]>([]);

interface Props {
  children: React.ReactNode;
}

const PricesProvider = ({ children }: Props) => {
  const productSlug = useProduct((p) => p.slug);
  const [searchParams] = useSearchParams();
  const priceId = searchParams.get("id");
  const variant = searchParams.get("variant");
  const { visitId } = useParams<MatchParam<"VISIT_ID">>();

  const { currentData: data, isLoading } = useGetProductPricesQuery(
    {
      product: productSlug,
      stripe_id: priceId ? priceId : undefined,
      product_variant: variant ? variant.split("(")[0] : undefined,
      visit: visitId,
      active: true,
    },
    { refetchOnMountOrArgChange: true },
  );

  const products = useMemo(() => {
    if (data == null) return [];

    return data;
  }, [data]);

  if (isLoading === true) {
    return <Loading />;
  }

  return (
    <PricesContext.Provider value={products}>{children}</PricesContext.Provider>
  );
};

export default PricesProvider;
